/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Unlock_Card1_TitleInputs */

const en_home_unlock_card1_title = /** @type {(inputs: Home_Unlock_Card1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Your Policy`)
};

const fr_home_unlock_card1_title = /** @type {(inputs: Home_Unlock_Card1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer votre police`)
};

/**
* | output |
* | --- |
* | "Manage Your Policy" |
*
* @param {Home_Unlock_Card1_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_card1_title = /** @type {((inputs?: Home_Unlock_Card1_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_Card1_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_card1_title(inputs)
	return fr_home_unlock_card1_title(inputs)
});